<template>
    <Dialog
            :value="value"
            @input="$emit('input', $event)"
            title="Resultado da Importação de Assistentes"
            width="550"
            :buttons="buttons"
            :show-close-button="true"
    >
        <v-card-text>
            <v-list dense>
                <v-list-item v-for="(error, index) in errors" :key="index">
                    <v-list-item-content>
                        <!-- Substituir v-list-item-title por p -->
                        <span style="white-space: normal; word-wrap: break-word; overflow: visible;font-size: 12px;">
                            {{ index+1 }} - {{ error }}
                        </span>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card-text>
    </Dialog>
</template>
<script>
  export default {
    name: 'DialogExibirErrosImportacao',
    props: {
      errors: {
        type: Array,
        required: true,
        default: () => []
      },
      value: {
        type: Boolean,
        required: true
      },
      buttons: {
        type: Array,
        default: () => [
          {
            text: 'Fechar',
            color: 'primary',
            action: 'close'
          }
        ]
      }
    },
    methods: {
      closeDialog () {
        this.$emit('input', false)
      }
    }
  }
</script>

<style scoped></style>
